import { useState } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

function Login({ onLogin, onRegister, onDemoLogin }) {
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      if (mode === "register") {
        const response = await fetch(`${API_BASE_URL}/api/register`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ name, email, password }),
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "登録に失敗しました");
        }
        if (onRegister) {
          onRegister(data);
        }
      } else {
        const response = await fetch(`${API_BASE_URL}/api/login`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "ログインに失敗しました");
        }
        if (onLogin) {
          onLogin(data);
        }
      }
    } catch (err) {
      setError(err.message || "エラーが発生しました");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "grid",
      placeItems: "center",
      background: "linear-gradient(180deg, #f5f7ff 0%, #eef4ff 100%)",
      fontFamily: "Segoe UI, sans-serif",
    }}>
      <div style={{
        width: "min(440px, 90vw)",
        background: "white",
        borderRadius: "20px",
        boxShadow: "0 12px 35px rgba(95,111,255,0.15)",
        padding: "28px 24px",
      }}>
        <p style={{ margin: 0, color: "#5F6FFF", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", textAlign: "center" }}>
          FocusFlow
        </p>
        <h1 style={{ margin: "12px 0 10px", fontSize: "2.1rem", textAlign: "center" }}>
          {mode === "login" ? "ログイン" : "新規登録"}
        </h1>

        <div style={{ display: "flex", gap: "8px", marginBottom: "20px" }}>
          <button type="button" onClick={() => setMode("login")} style={{ flex: 1, padding: "12px", borderRadius: "10px", border: mode === "login" ? "1px solid #5F6FFF" : "1px solid #dfe7ff", background: mode === "login" ? "#eef1ff" : "white", fontWeight: 700, cursor: "pointer" }}>
            ログイン
          </button>
          <button type="button" onClick={() => setMode("register")} style={{ flex: 1, padding: "12px", borderRadius: "10px", border: mode === "register" ? "1px solid #5F6FFF" : "1px solid #dfe7ff", background: mode === "register" ? "#eef1ff" : "white", fontWeight: 700, cursor: "pointer" }}>
            新規登録
          </button>
        </div>

        <form onSubmit={submit} style={{ display: "grid", gap: "14px" }}>
          {mode === "register" && (
            <label style={{ display: "grid", gap: "8px", fontWeight: 600 }}>
              名前
              <input value={name} onChange={(e) => setName(e.target.value)} style={{ padding: "12px 14px", border: "1px solid #dfe7ff", borderRadius: "10px" }} placeholder="山田 太郎" />
            </label>
          )}

          <label style={{ display: "grid", gap: "8px", fontWeight: 600 }}>
            メールアドレス
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ padding: "12px 14px", border: "1px solid #dfe7ff", borderRadius: "10px" }} placeholder="you@example.com" />
          </label>

          <label style={{ display: "grid", gap: "8px", fontWeight: 600 }}>
            パスワード
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ padding: "12px 14px", border: "1px solid #dfe7ff", borderRadius: "10px" }} placeholder="••••••••" />
          </label>

          {error && (
            <div style={{ color: "#c62828", background: "#fff0f0", border: "1px solid #ffc2c2", borderRadius: "10px", padding: "10px 12px", fontSize: "0.92rem" }}>
              {error}
            </div>
          )}

          <button type="submit" disabled={isSubmitting} style={{ padding: "13px 16px", border: "none", borderRadius: "12px", background: "linear-gradient(135deg, #5F6FFF, #7A5CF1)", color: "white", fontWeight: 700, cursor: "pointer" }}>
            {isSubmitting ? "処理中..." : mode === "login" ? "ログイン" : "登録して開始"}
          </button>
        </form>

        <button
          type="button"
          onClick={onDemoLogin}
          style={{
            marginTop: "16px",
            width: "100%",
            padding: "12px 18px",
            border: "1px solid #dfe7ff",
            borderRadius: "12px",
            background: "#f8faff",
            color: "#42506a",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          デモログインで試す
        </button>
      </div>
    </div>
  );
}

export default Login;
